import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
const included = ['7 complete system volumes', '120 Ready-to-Teach Dance Fitness Classes', '120 Professional Choreography Systems', 'Cueing & Coaching System', 'Annual Class Planning Frameworks', 'Class templates for 30, 45 & 60 minutes', 'Warm-up, mobility & cool-down libraries', '5 premium bonuses included', 'Instant digital access', '7-day money-back guarantee'];
export function PricingSection() {
  return <section id="pricing" className="bg-navy px-4 py-20 text-white" data-id="element-157">
      <div className="mx-auto max-w-3xl" data-id="element-158">
        <header className="mb-10 text-center" data-id="element-159">
          <p className="headline-kicker text-xs font-bold text-violet-light" data-id="element-160">
            COMPLETE OFFER
          </p>
          <h2 className="mt-3 font-display text-3xl font-black uppercase sm:text-5xl" data-id="element-161">
            Your complete instructor{' '}
            <span className="text-violet-light" data-id="element-162">system.</span>
          </h2>
          <p className="mt-3 text-sm text-slate-200" data-id="element-163">
            High-value resources, ready for your next class.
          </p>
        </header>
        <article className="relative rounded-3xl border border-white/20 bg-white p-1 shadow-[0_20px_50px_rgba(0,0,0,.28)]" data-id="element-164">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-violet px-4 py-1 text-xs font-bold tracking-wide text-white" data-id="element-165">
            50% OFF TODAY
          </span>
          <div className="rounded-[1.3rem] bg-white p-6 text-center text-navy sm:p-10" data-id="element-166">
            <h3 className="font-display text-3xl font-black uppercase" data-id="element-167">
              Dance Fitness Instructor Pro™
            </h3>
            <p className="mt-2 text-sm text-slate-600" data-id="element-168">
              The complete ready-to-teach system for confident, successful
              instructors.
            </p>
            <ul className="mx-auto my-6 max-w-md space-y-2 rounded-xl border border-line bg-cloud p-4 text-left" data-id="element-169">
              {included.map(item => <li key={item} className="flex gap-2 text-sm text-slate-700" data-id="element-170">
                  <CheckIcon className="mt-0.5 shrink-0 text-violet" size={16} data-id="element-171" />
                  {item}
                </li>)}
            </ul>
            <p className="text-lg text-slate-400 line-through" data-id="element-172">USD 105.00</p>
            <p className="mt-1 text-xl font-medium" data-id="element-173">
              TODAY:{' '}
              <strong className="ml-1 text-5xl text-violet" data-id="element-174">USD 27.00</strong>
            </p>
            <CheckoutButton className="mt-7 w-full sm:w-auto" data-id="element-175">
              YES! I WANT THE COMPLETE SYSTEM
            </CheckoutButton>
            <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-600" data-id="element-176">
              <span className="flex items-center gap-1" data-id="element-177">
                <ZapIcon size={14} className="text-violet" data-id="element-178" />
                Instant Access
              </span>
              <span className="flex items-center gap-1" data-id="element-179">
                <ShieldCheckIcon size={14} className="text-violet" data-id="element-180" />
                7-Day Guarantee
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}